var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: [
        "unum-drawer-compare",
        {
          "unum-drawer-compare--notify": _vm.chosenPlatforms.length,
          "unum-drawer-compare--active": _vm.is.compareDrawerOpen
        }
      ]
    },
    [
      _c(
        "section",
        { staticClass: "unum-drawer-compare__head" },
        [
          _c(
            "unum-button",
            {
              attrs: { small: "", outline: "", color: "white" },
              nativeOn: {
                click: function($event) {
                  return _vm.toggleCompareDrawerEvent("open")
                }
              }
            },
            [_vm._v("Compare")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "unum-drawer-compare__body" },
        [
          _c(
            "span",
            {
              staticClass: "menu-close",
              on: {
                click: function($event) {
                  return _vm.toggleCompareDrawerEvent("close")
                }
              }
            },
            [_vm._v("Close Drawer")]
          ),
          _vm._v(" "),
          _c("h3", [_vm._v("Your Selected Platforms:")]),
          _vm._v(" "),
          _vm.chosenPlatforms.length
            ? _c(
                "ul",
                { staticClass: "unum-drawer-compare__list" },
                _vm._l(_vm.chosenPlatforms, function(platform) {
                  return _c(
                    "li",
                    { key: platform[".key"] },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(platform.displayName) +
                          "\n        "
                      ),
                      _c(
                        "unum-button",
                        {
                          attrs: { small: "", outline: "", color: "red" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.removePlatformEvent(platform)
                            }
                          }
                        },
                        [_vm._v("\n          Remove\n        ")]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "unum-button",
            {
              attrs: { fullWidth: "" },
              nativeOn: {
                click: function($event) {
                  return _vm.goToCompare($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.chosenPlatforms.length > 1
                      ? "Compare These Platforms"
                      : "See Details"
                  ) +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c017fe02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c017fe02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DrawerCompare.vue
// module id = null
// module chunks = 